<template>
  <div>
    <list
      row-key="UserId"
      ref="list"
      unit="个人德育类荣誉"
      :expand-all-row="true"
      :page="true"
      :query-params="params"
      :show-checkbox="true"
      :show-query="showQuery"
      :get-data-func="api.list"
      :show-reset="true"
      :setTable="true"
      table-title="信息列表"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">

        <el-form-item label="姓名">
          <el-input v-model="params.TeacherName" size="mini"  placeholder="请填写姓名" clearable/>
        </el-form-item>
        <el-form-item label="荣誉名称">
                <el-autocomplete
                clearable
                v-model="params.EduHonerName"
                :fetch-suggestions="querySearchAsync"
                placeholder="请输入内容"
                @select="handleSelect"
                style="width:100%"
              ></el-autocomplete>
        </el-form-item>
    <el-form-item label="获得开始时间">
      <el-date-picker
      v-model="params.StartDate"
      type="date"
      value-format="yyyy-MM-dd"
      style="width:184px;"
      placeholder="选择日期">
       </el-date-picker>
    </el-form-item>
     <el-form-item label="获得结束时间">
      <el-date-picker
      v-model="params.EndDate"
      type="date"
      style="width:184px;"
      value-format="yyyy-MM-dd"
      placeholder="选择日期">
    </el-date-picker>
    </el-form-item>
        <el-form-item label="级别">
          <el-select v-model="params.GdLv" clearable  size="mini">
            <el-option
                v-for="item in ThemeLvList"
                :value="item.DataName"
                :label="item.DataName"
                :key="item.DataName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="颁发单位">
          <el-input v-model="params.Organizer" size="mini" placeholder="请填写颁发单位" clearable/>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="params.Status"  size="mini" clearable>
            <el-option :value="0" label="草稿"></el-option>
            <el-option :value="1" label="待审核"></el-option>
            <el-option :value="2" label="退回"></el-option>
            <el-option :value="3" label="已审核"></el-option>
          </el-select>
        </el-form-item>
      </template>
     <template slot="table">
          <el-table-column prop="TeacherName" label="姓名" width="65px"/>
          <el-table-column prop="EduHonerName" label="荣誉名称" min-width="200px"/>
          <el-table-column prop="GetDate" label="获得时间" width="90px">
            <template slot-scope="{row}">
              <span>{{$commonJs.toDateString(row.GetDate)}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="GdLv" label="级别"  width="55px"/>
          <el-table-column prop="Organizer" label="颁发单位"/>
          <el-table-column prop="CreateTime" label="提交时间" :width="isMB?85:135"/>
          <el-table-column label="状态" align="center" width="90">
            <template slot-scope="{row}">
              <span size="mini">{{row.Status==0?'草稿':row.Status==1?'待审核':row.Status==2?'退回':row.Status==3?'已审核':''}}</span>
            </template>
          </el-table-column>
           <slot name="column"></slot>
          <!-- <el-table-column prop="" label="操作" align="center" width="80">
            <template slot-scope="{row}">
                <el-button type="text" @click="editById(row.ThemeId)" v-if="(row.Status==0 || row.Status==2) || $permission.canReview()">编辑</el-button>
                <el-button type="text" v-if="row.Status==1 && $permission.canReview()" @click.stop="check(row)" >审核</el-button>
                <el-button type="text" v-if="row.Status==1 && row.AddTeacherId==TeacherId" @click.stop="check(row)" >撤销</el-button>
                <el-button type="text" v-if="row.Status==3 && $permission.canReview()" @click.stop="check(row)" >撤销审核</el-button>
            </template>
          </el-table-column> -->
      </template>
    </list>

    <exam-dialog ref="examDialog" in-dialog selectable :multiple="false" @select="setThis"></exam-dialog>
    <import-dialog ref="importDialog" @upload-success="reload" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import examDialog from "@/components/achieve/exam/listDialog";
import importDialog from "./importDialog";
export default {
  props: {
    ThemeLvList: {
      type: Array,
      default: [],
    }
  },
  mixins: [listMixin],
  components: { 
    list,
    examDialog,
    importDialog
  },
  data() {
    return {
      api: require("@/api/gd/eduhoner").default,
      Base_api: require("@/api/gd/basedata").default,
      AnalyseId: null,
      params: {
        TeacherName:"",
        ThemeName: "",
        GetDate:"",
        GdType: "",
        GdLv:"",
        Organizer: "",
        EduHonerName:"",
        Status:""
      },
      data: {
        Entries: [],
        Classes: [],
        ThisExamId: null,
        SchoolYear: "",
        AnalyseType: 0,
      },
      Entries: [],
      EntryLvSn: "",
      table: [],
      Lvs: [],
      tableData: [],
      ClassIds: [],
      TermId: null,
      loading: false,
      searchParams: {},
      isMB: this.$store.state.isMB,
      restaurants:[]
    };
  },
  mounted() {
    this.Base_api.list({ClassName:'德育类荣誉名称',Status:1}).then(res => {
      if(res.Code==0){
        res.Data.forEach(e=>{
          this.restaurants.push({ "value": e.DataName, "DataName": e.DataName })
        })
        //  this.restaurants=res.Data
      }
    })
  },
  methods: {
    handleSelect(item) {
      this.data.EduHonerName=item.value
    },
    querySearchAsync(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
        cb(results);
    },
    createStateFilter(queryString) {
      return (state) => {
        return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
    },
    onImport() {
      this.$refs.importDialog.open().then((that) => {
        that.setData(this.params);
      });
    },
    // getData() {
    //   this.getDataFunc()
    // },
    onExamDialog(type) {
      if(!this.data.SchoolYear) {
        this.$message.error("请先选择入学年份")
        return
      }
    },
    setThis(exam) {
      this.TermId = exam.TermId;
      this.data.ThisExamId = exam.ExamId;
      this.params.ThisLvSn = exam.ExamCode;
    },
    confirm(data) {
      this.Entries.forEach((e,index) => {
        e.EntryRatio = Number(data[index].ExamRatio)
      })
      this.params.EntryLvSn = this.EntryLvSn;
      this.data.Entries = this.Entries;
    },
    confirm2(data) {
      let obj = { AnalyseId: this.AnalyseId, ClassIds: data.ClassIds };
      this.ClassIds = data.ClassIds;
      if(data.type === 0) {
        obj.RecentTop5 = true;
      } else if(data.type === 1) {
        obj.Bad30 = true;
      } else if(data.type === 2) {
        obj.Good30 = true;
      }
      this.loading = true;
      this.searchParams = obj;
      this.api.filterAnalyse(obj).then(res => {
        this.loading = false;
        if(res.Code == 0) {
          this.AnalyseId = res.Data.AnalyseId;
          this.tableData = [];
          this.table = res.Data.Table;
          this.Lvs = res.Data.Lvs;
          this.data.ThisExamId = res.Data.ThisExamId;
          this.table.forEach(e => {
            let obj = {};
            obj.a = [];
            e.forEach(n => {
              obj.a.push(n)
            })
            this.tableData.push(obj);
          })
          if(this.tableData.length == 0) {
            this.$message.warning("当前考试暂无数据");
          }
        }
      })
    },
    getDataFunc() {
      this.api.getLastAnalyse(0).then(res => {
        this.AnalyseId = res.Data.AnalyseId;
        this.table = res.Data.Table;
        this.Lvs = res.Data.Lvs;
        this.data.ThisExamId = res.Data.ThisExamId;
        this.data.SchoolYear = res.Data.SchoolYear;
        this.params.ThisLvSn = res.Data.ThisExamCode;
        this.TermId = res.Data.TermId;
        this.table.forEach(e => {
          let obj = {};
          obj.a = [];
          e.forEach(n => {
            obj.a.push(n)
          })
          this.tableData.push(obj);
        });
        res.Data.Entries.forEach((e,index) => {
          this.params.EntryLvSn += e.EntryCode;
          if(res.Data.Entries[index+1]) {
            this.params.EntryLvSn += '，';
          }
          this.data.Entries.push({
            EntryExamId: e.EntryExamId,
            EntryRatio: e.EntryRatio
          })
        })
        // this.loaded = true;
      })
    },
    reset() {
      this.data.Entries = [];
      this.data.ThisExamId = null;
      this.params.ThisLvSn = "";
      this.params.EntryLvSn = "";
      this.TermId = null;
    },
    onExport() {
      this.api.export(this.params)
    },
  },
};
</script>
<style lang="scss">
.titleLink{
  cursor:pointer;
  &:hover{
    color: #4098ff;
  }
}
</style>